/*global $ */
import ko from 'knockout';

export function registerComponent() {
  ko.components.register('date-picker', {
    template: { element: 'date-picker-template' },
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new SearchDatePickerViewModel(params, componentInfo);
      },
    },
  });
}

function SearchDatePickerViewModel(params, componentInfo) {
  var monthNames = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];

  var self = this;

  var now = new Date();
  var minDate = (new Date(now.getFullYear(), now.getMonth(), now.getDate()));
  var maxDate = (new Date(now.getFullYear() + 1, 12 - 1, 31));
  var minTime = minDate.getTime();
  var maxTime = maxDate.getTime();

  self.arrival = params.Arrival;
  self.arrivalCorrection = params.ArrivalCorrection;
  self.arrivalCorrectionVisible = params.ArrivalCorrectionVisible;
  self.fieldNameArrival = params.FieldNameArrival;
  self.fieldNameArrivalCorrection = params.FieldNameArrivalCorrection;
  self.fieldNameArrivalCorrectionVisible = params.FieldNameArrivalCorrectionVisible;
  self.months = ko.observableArray();
  self.selectedMonth = ko.observable();
  self.selectedArrival = ko.observable();
  self.hoverDay = ko.observable();
  self.content = ko.observable();

  var years = [];
  for (var year = minDate.getFullYear(); year <= maxDate.getFullYear(); year++) {
    years.push(year);
  }

  self.yearOptions = ko.observableArray(years);
  self.monthOptions = ko.observableArray([]);

  params.Arrival.subscribe(setContent);

  var arrival = parseArrival(params.Arrival());

  var currentMonth = new Date();
  if (arrival) {
    self.selectedArrival(arrival.getTime());
    currentMonth = new Date(arrival.getTime());
  } else {
    self.selectedArrival(null);
  }

  currentMonth.setDate(1);

  self.yearValue = ko.observable(currentMonth.getFullYear());

  self.selectedMonth.subscribe(function selectedMonthChanged(newValue) {
    var newMonth = new Date(newValue);
    var year = newMonth.getFullYear();
    self.yearValue(year);
    var month1 = new Month(year, newMonth.getMonth() + 1, self.selectedArrival, self.hoverDay);
    self.months.splice(0, 1, month1);

    var options = [];
    for (var i = 0; i < 12; i++) {
      var month = new Date(year, i, 1);
      var disabled = month > maxDate || addMonths(month, 1) < minDate;
      options.push(new MonthOption(month, monthNames[i], disabled));
    }

    self.monthOptions(options);
  });

  self.selectedMonth(currentMonth.getTime());

  self.yearValue.subscribe(function (newValue) {
    var selectedMonth = new Date(self.selectedMonth());
    selectedMonth.setFullYear(newValue);
    if (selectedMonth < minDate) {
      selectedMonth.setMonth(minDate.getMonth());
    } else if (selectedMonth > maxDate) {
      selectedMonth.setMonth(maxDate.getMonth());
    }
    self.selectedMonth(selectedMonth.getTime());
  });

  setContent();

  self.setOptionDisable = function (option, item) {
    ko.applyBindingsToNode(option, { disable: item.disabled }, item);
  };

  self.nextMonth = function () {
    self.selectedMonth(addMonths(new Date(self.selectedMonth()), 1).getTime());
  };

  self.previousMonth = function () {
    self.selectedMonth(addMonths(new Date(self.selectedMonth()), -1).getTime());
  };

  self.mouseover = function (e) {
    self.hoverDay(e.time);
  };

  self.mouseout = function () {
    self.hoverDay(null);
  };

  self.select = function (e) {
    if (e.isValid()) {
      if (self.selectedArrival() && self.selectedArrival() == e.time) {
        self.selectedArrival(null);
        self.arrival('');
      } else {
        self.selectedArrival(e.time);
        var date = new Date(e.time);
        self.arrival(date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear());
      }

      $(componentInfo.element).trigger('periodselected');
    }
  };

  self.currentMonthName = ko.pureComputed(function () {
    return self.months()[0].name;
  }, self);

  self.currentMonthYear = ko.pureComputed(function () {
    return self.months()[0].year;
  }, self);

  self.nextMonthDisabled = ko.pureComputed(function () {
    return addMonths(new Date(self.selectedMonth()), 1) > maxDate;
  }, self);

  self.previousMonthDisabled = ko.pureComputed(function () {
    return addDays(new Date(self.selectedMonth()), -1) < minDate;
  }, self);

  function Month(year, month, arrival, hover) {
    this.id = '' + year + month;
    this.year = year;
    this.month = month;
    this.name = monthNames[month - 1];
    this.weeks = [];

    var startDate = new Date(year, month - 1, 1);
    startDate = addDays(startDate, -((startDate.getDay() - 1 + 7) % 7));

    this.startDate = startDate;

    for (var i = 0; i < 6; i++) {
      this.weeks[i] = new Week(month, startDate, arrival, hover);
      startDate = addDays(startDate, 7);
    }
  }

  function Week(month, startDate, arrival, hover) {
    this.startDate = startDate;
    this.days = [];

    for (var i = 0; i < 7; i++) {
      this.days[i] = new Day(month, startDate, arrival, hover);
      startDate = addDays(startDate, 1);
    }
  }

  function Day(month, date, arrival, hover) {
    this.time = date.getTime();
    this.number = date.getDate();

    this.isInMonth = date.getMonth() === (month - 1);

    this.isHovered = ko.pureComputed(function () {
      return this.isInMonth && hover() === this.time;
    }, this);

    this.isSelected = ko.pureComputed(function () {
      return this.isInMonth && arrival() === this.time;
    }, this);

    this.isOutOfRange = ko.pureComputed(function () {
      return this.isInMonth && !(minTime <= this.time && maxTime >= this.time);
    }, this);

    this.isValid = ko.pureComputed(function () {
      return !this.isOutOfRange();
    }, this);

    this.isDisabled = ko.pureComputed(function () {
      return !this.isValid();
    }, this);

    this.isEmpty = ko.pureComputed(function () {
      return !this.isInMonth();
    }, this);
  }

  function addDays(date, days) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
  }

  function addMonths(date, months) {
    return new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
  }

  function setContent() {
    var arrival = parseArrival(self.arrival());
    if (arrival) {
      self.content(arrival.getDate() + ' ' + monthNames[arrival.getMonth()] + ' ' + arrival.getFullYear());
    } else {
      self.content('&nbsp;');
    }
  }

  function parseArrival(arrival) {
    var parts = arrival.split(/[\s\-./]+/);
    if (parts.length !== 3) {
      return null;
    } else {
      return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    }
  }

  function MonthOption(value, name, disabled) {
    this.value = value.getTime();
    this.name = name;
    this.disabled = disabled;
  }
}
